import { baseApi } from "./baseApi";

const DELIVERY_COLLECTION_BASE_URL = "/deliveryCollection";

export const deliveryCollectionApi = baseApi.injectEndpoints({
  tagTypes: ["DeliveryCollection"],

  endpoints: (builder) => ({
    getDeliveryCollectionList: builder.query({
      query: (params) => ({
        url: `${DELIVERY_COLLECTION_BASE_URL}/deliveryCollection-list`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result?.data.map(({ _id }) => ({
                type: "DeliveryCollection",
                _id,
              })),
              { type: "DeliveryCollection", id: "LIST" },
            ]
          : [{ type: "DeliveryCollection", id: "LIST" }],
    }),

    getDeliveryCollectionListForVendor: builder.query({
      query: (params) => ({
        url: `${DELIVERY_COLLECTION_BASE_URL}/deliveryVendor`,
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
              ...result.data.map(({ _id }) => ({
                type: "DeliveryCollection",
                id: _id,
              })),
              { type: "DeliveryCollection", id: "LIST" },
            ]
          : [{ type: "DeliveryCollection", id: "LIST" }],
    }),

    getDeliveryCollectionDetail: builder.query({
      query: (id) =>
        `${DELIVERY_COLLECTION_BASE_URL}/deliveryCollection-edit/${id}`,
      providesTags: (result, error, id) => [
        { type: "DeliveryCollection", id },
        { type: "DeliveryCollection", id: "LIST" },
      ],
    }),

    createDeliveryCollection: builder.mutation({
      query: (payload) => ({
        url: `${DELIVERY_COLLECTION_BASE_URL}/deliveryCollection-create`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "DeliveryCollection", id: "LIST" },
      ],
    }),

    updateDeliveryCollection: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${DELIVERY_COLLECTION_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "DeliveryCollection", id },
        { type: "DeliveryCollection", id: "LIST" },
      ],
    }),

    listShipmentsByDeliveryCollectionId: builder.query({
      query: ({ deliveryCollectionId, page, limit }) => ({
        url: `${DELIVERY_COLLECTION_BASE_URL}/${deliveryCollectionId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "DeliveryCollection", id: _id },
        { type: "DeliveryCollection", id: "LIST" },
      ],
    }),
    getDeliveryCollectionDDL: builder.query({
      query: (params) => {
        return { url: `${DELIVERY_COLLECTION_BASE_URL}/ddl`, params };
      },
    }),
    addFinanceDeliveryCollection: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `${DELIVERY_COLLECTION_BASE_URL}/${id}/finance-collection`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "DeliveryCollection", id },
        { type: "DeliveryCollection", id: "LIST" },
      ],
    }),

    rejectDeliveryCollection: builder.mutation({
      query: (id) => ({
        url: `${DELIVERY_COLLECTION_BASE_URL}/${id}/reject-collection`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "DeliveryCollection", id },
        { type: "DeliveryCollection", id: "LIST" },
      ],
    }),

    getShipmentDetails: builder.query({
      query: ({ shipmentId, account, entity }) => ({
        url: `${DELIVERY_COLLECTION_BASE_URL}/shipment-details/${shipmentId}`,
        method: "GET",
        params: { account, entity },
      }),
      providesTags: (result, error, { shipmentId }) => [
        { type: "Shipment", id: shipmentId },
      ],
    }),

    listDeliveryCollectionBillingPrint: builder.query({
      query: ({ id, page, limit }) => ({
        url: `${DELIVERY_COLLECTION_BASE_URL}/${id}/billingPrint`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "DeliveryCollection", id: _id },
        { type: "DeliveryCollection", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetDeliveryCollectionListQuery,
  useLazyGetDeliveryCollectionListQuery,
  useGetDeliveryCollectionListForVendorQuery,
  useLazyGetDeliveryCollectionListForVendorQuery,
  useGetDeliveryCollectionDetailQuery,
  useCreateDeliveryCollectionMutation,
  useUpdateDeliveryCollectionMutation,
  useLazyGetDeliveryCollectionDDLQuery,
  useListShipmentsByDeliveryCollectionIdQuery,
  useLazyListShipmentsByDeliveryCollectionIdQuery,
  useAddFinanceDeliveryCollectionMutation,
  useRejectDeliveryCollectionMutation,
  useLazyGetShipmentDetailsQuery,
  useLazyListDeliveryCollectionBillingPrintQuery,
} = deliveryCollectionApi;
